export default __webpack_public_path__ + "static/media/weatherApp.9e1def33.png";